export default __webpack_public_path__ + "static/media/orangeExtraSmall.66f4ff86.svg";